import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const PreviousMaterials = () => {
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  // Each subject can have MULTIPLE Google Drive folders.
  // **INSTRUCTIONS**: Add folder objects with { name, link } to each subject's folders array.
  // How to get a folder ID: Open the folder in Google Drive, copy the ID from the URL (between /folders/ and the next /)
  // Example URL: https://drive.google.com/drive/folders/1abc123def456 → ID is 1abc123def456
  // Then use: https://drive.google.com/drive/folders/1abc123def456
  
  const materials = {
    "Engineering Graphics": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/1nhdJXe-GSQ55NrYSoJCh6oe7IM6nRSjf?usp=drive_link" }
      ],
    },
    "Discrete Mathematics": {
      folders: [
        { name: "Lecture Notes and Handwritten Notes", link: "https://drive.google.com/drive/folders/1mDU7U5xFphEhwVFYRRnilGmTleBtGWCG?usp=drive_link" }, 
      ],
    },
    "Python": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/1bCcqbIJ07sW3AaYuymrPx9OKgAYe-Eie?usp=drive_link" },
      ],
    },
    "BEEE": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/1Yda112eJjS3DacqqvLVUgak8u2lGvWRe?usp=drive_link" },
      ],
    },
    "C Programming": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/19y9R_81MyUBkHFQSAojCOHoivdwiL9KM?usp=drive_link" },
      ],
    },
    "Communication System": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/1qqmjIbiqjAPb0lLkLeKt5bfmtE8uVYVv?usp=drive_link" }
      ],
    },
    "Computer Information and Ethics": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/1mzMARkl28VIZVo_peF8_qyakB2YVjPLE?usp=drive_link" },
      ],
    },
    "Probability and Statistics": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/1VmkZN34kcD7s0r4mpKH3j9WVa4dHOmMf?usp=drive_link" }
      ],
    },
    "Computer Architecture": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/1loKZ2Ylh2aooxpHDgJ9T8eguqsKKvYyL?usp=drive_link" },
      ],
    },
    "Data Structures": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/1xPRvPlrzWkVXexnMlyGiM39XAa-7oNhr?usp=drive_link" },
      ],
    },
    "Data Structures LAB": {
      folders: [
        { name: "Lab Codes", link: "https://drive.google.com/drive/folders/1BW-kT-PGvN57BO1hjde3zUhWsFOSz0v2?usp=drive_link" },
      ],
    },
    "java OOPS": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/1_01Pt5nEMA5egOUaVjdAJU8TA073k0or?usp=drive_link" }
      ],
    },
    "Computer Networks": {
      folders: [
        { name: "CIE 1 Notes", link: "https://drive.google.com/drive/folders/1xPDb2u1ee3IBHOsIlo-Tfq7XDYN4MLZd?usp=drive_link" },
        { name: "CIE 2 Notes", link: "https://drive.google.com/drive/folders/1hpwySm6XiGcTl4TdFrc258PCO1U2gTKb?usp=drive_link" },
        { name: "CIE 3 Notes", link: "https://drive.google.com/drive/folders/1RVTm_XFptFmg4HsmCWdJfwm_U6OjFjKM?usp=drive_link" },
      ],
    },
    "Agile Metholodies": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/1pkPh0Eil8OFu2LgrA3C5SfnhJnHk5wit?usp=drive_link" }
      ],
    },
    "Numerical Regression and Analysis": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/1h-7Oy35sp5s-6H0-EhGTNZ7wFbTwFxUp?usp=drive_link" }
      ],
    },
    "Theory Of Computation": {
      folders: [
        { name: "CIE 1 Notes", link: "https://drive.google.com/drive/folders/1oIwNvhCY7wsc-g-tCDBNlm9gGwU7hQ8N?usp=drive_link" },
        { name: "CIE 2 Notes", link: "https://drive.google.com/drive/folders/14jb3JFe4SuWUskpvNjRF5GNaO0U_uYw-?usp=drive_link" },
      ],
    },
    "Embedded System Design": {
      folders: [
        { name: "Unit 1 Notes", link: "https://drive.google.com/drive/folders/1A3Vl9z5V6_YTOnxaB2R-F_Rde72WHdI6?usp=drive_link" },
        { name: "Unit 2 Notes", link: "https://drive.google.com/drive/folders/1GFFw9YwE5n7xxGjAnY5IPeT_gnZyFKzi?usp=drive_link" },
        { name: "Unit 3 Notes", link: "https://drive.google.com/drive/folders/1PYA1NJtqM1ztfXCfCZnNr29h_H13Z7Yn?usp=drive_link" },
        { name: "Unit 4 Notes", link: "https://drive.google.com/drive/folders/1dEt7OzGH-DT3mQHG7Tbvhhqam-3iZYwn?usp=drive_link" },
        { name: "Unit 5 Notes", link: "https://drive.google.com/drive/folders/1gdUbCkxqHWLxC1dmtbqkh_4cekrAsat2?usp=drive_link" },
      ],
    },
    "DataBase Management System": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/1example_dbms_notes" },
        { name: "Query Examples", link: "https://drive.google.com/drive/folders/1example_dbms_queries" },
      ],
    },
    "Operating System": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/1example_os_notes" },
        { name: "Algorithms", link: "https://drive.google.com/drive/folders/1example_os_algorithms" },
      ],
    },
    "Design and Analysis of Algorithms": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/11jjQIVVg3eMi5QTL-FWlVzcFPK3JQ1oZ?usp=drive_link" },
      ],
    },
    "Principles of Management": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/1Yt4Ri09DW1miht4FWzyy9sMircE9woR-?usp=drive_link" },
      ],
    },
    "Software Engineering": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/1example_se_notes" },
        { name: "Design Patterns", link: "https://drive.google.com/drive/folders/1example_se_patterns" },
      ],
    },
    "Municipal Solid Waste Management": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/141i16uuzdS7ILlxsvLAghf43p1bm0azI?usp=drive_link" },
      ],
    },
    "Artificial Intelligence": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/1dBGcCwm3nR0sb13sHG2dqjK8dZhkKjs2?usp=drive_link" },
      ],
    },
    "Cloud Computing": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/1p7VWyYKSYgQgGQUswe8Vu1fAM2cPP8LZ?usp=drive_link" },
      ],
    },
    "Web Development": {
      folders: [
        { name: "Ln 1 Notes", link: "https://drive.google.com/drive/folders/1b_H4jguF9xv8kCzf_6BzGbKcAvQXnj3n?usp=drive_link" },
        { name: "Ln 2 Notes", link: "https://drive.google.com/drive/folders/1rg3kv08J4O42YJ4QvisO8YzZQ9nXbkNn?usp=drive_link" },
        { name: "Ln 3 Notes", link: "https://drive.google.com/drive/folders/1example_webdev_code" },
        { name: "Ln 4 Notes", link: "https://drive.google.com/drive/folders/1RGyph3UIF7SZUCJH3CX7wF8502RkmU5j?usp=drive_link" },
        { name: "Ln 5 Notes", link: "https://drive.google.com/drive/folders/1fw8EqPG2O677dkpCXMlG6_j45XiV4GaL?usp=drive_link" },
      ],
    },
    "Principles of Compiler Design": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/1example_pcd_notes" },
        { name: "Compiler Tools", link: "https://drive.google.com/drive/folders/1example_pcd_tools" },
      ],
    },
    "Machine Learning": {
      folders: [
        { name: "CIE 1 Notes", link: "https://drive.google.com/drive/folders/1bFriJdOrDMJtUDNjYnsoNRy_NCHg2lv_?usp=drive_link" },
        { name: "CIE 2 Notes", link: "https://drive.google.com/drive/folders/1LQl3hYFB7M3bVv3WXYOpLAeubdP22ApA?usp=drive_link" },
        { name: "CIE 3 Notes", link: "https://drive.google.com/drive/folders/1PQREgldjviRh2YkDLdt5eVzVHXtWEkSr?usp=drive_link" },
      ],
    },
    "Blockchain Technologies": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/1erKgn-bV6EZkmh3Ta6AxkRV37sAKZs4I?usp=drive_link" },
      ],
    },
    "Internet Of Things": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/1UtuE9Zv3gU8sV7U6NCknR0HLEceFdTuF?usp=drive_link" },
      ],
    },
    "Renewable Energy Sources": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/1J0kjbiWt6u4hpZA1ISKZDZ1k0CxcdWn7?usp=drive_link" },
      ],
    },
    "Cyber Law and Ethics": {
      folders: [
        { name: "Lecture Notes", link: "https://drive.google.com/drive/folders/1_9QOQvpKWiJix9_3MIdmZ2OqSzcR7A2y?usp=drive_link" },
      ],
    },
  };

  const subjects = Object.keys(materials);

  const filteredSubjects = subjects.filter((s) =>
    s.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Reliable inline SVG folder icon (no external network dependency)
  const FolderIcon = ({ className }) => (
    <svg
      viewBox="0 0 64 64"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="folderGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#60a5fa" />
          <stop offset="100%" stopColor="#22d3ee" />
        </linearGradient>
      </defs>
      <path
        d="M6 16c0-2.2 1.8-4 4-4h14l4 5h26c2.2 0 4 1.8 4 4v27c0 2.2-1.8 4-4 4H10c-2.2 0-4-1.8-4-4V16z"
        fill="url(#folderGrad)"
      />
      <path d="M6 22h52v25c0 2.2-1.8 4-4 4H10c-2.2 0-4-1.8-4-4V22z" fill="#1e40af" opacity="0.35" />
    </svg>
  );

  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.06,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30, scale: 0.9 },
    show: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { type: "spring", stiffness: 260, damping: 20 },
    },
  };

  return (
    <div className="min-h-screen relative overflow-hidden bg-slate-950 p-6">
      {/* Animated Background Glow */}
      <div className="fixed inset-0 -z-10 overflow-hidden">
        <motion.div
          animate={{
            x: [0, 40, 0],
            y: [0, 30, 0],
          }}
          transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
          className="absolute top-20 left-20 w-96 h-96 bg-blue-600 rounded-full blur-[160px] opacity-20"
        />
        <motion.div
          animate={{
            x: [0, -30, 0],
            y: [0, -40, 0],
          }}
          transition={{ duration: 14, repeat: Infinity, ease: "easeInOut" }}
          className="absolute bottom-20 right-20 w-96 h-96 bg-cyan-500 rounded-full blur-[160px] opacity-20"
        />
        <motion.div
          animate={{
            x: [0, 25, 0],
            y: [0, -25, 0],
          }}
          transition={{ duration: 16, repeat: Infinity, ease: "easeInOut" }}
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-purple-600 rounded-full blur-[160px] opacity-10"
        />
      </div>

      <div className="max-w-7xl mx-auto">
        <br />

        {/* Title */}
        <motion.h1
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="text-4xl md:text-4xl font-extrabold text-center mb-3 bg-gradient-to-r from-blue-300 via-white to-cyan-300 bg-clip-text text-transparent tracking-tight"
        >
          Previous Year Materials
        </motion.h1>

        {/* Search for Subjects (when folder list shown) */}
        <AnimatePresence>
          {!selectedSubject && (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.4 }}
              className="flex justify-center mb-6"
            >
              <div className="relative w-full max-w-lg">
                <input
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search subjects..."
                  className="w-full max-w-lg px-4 py-2 rounded-lg bg-white/10 border border-white/10 text-white placeholder-white/60 focus:outline-none"
                />
              </div>
            </motion.div>
          )}
        </AnimatePresence>

        {/* Folder View */}
        <AnimatePresence mode="wait">
          {!selectedSubject && (
            <motion.div
              key="folders"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0, transition: { duration: 0.25 } }}
            >
              <h2 className="text-white text-xl font-semibold mb-8">
                Select Subject
              </h2>

              {filteredSubjects.length === 0 ? (
                <motion.p
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  className="text-white/50 text-center py-10"
                >
                  No subjects match "{searchQuery}"
                </motion.p>
              ) : (
                <motion.div
                  variants={containerVariants}
                  initial="hidden"
                  animate="show"
                  className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8"
                >
                  {filteredSubjects.map((subject) => (
                    <motion.div
                      key={subject}
                      variants={cardVariants}
                      layout
                      whileHover={{
                        y: -12,
                        scale: 1.06,
                        transition: { type: "spring", stiffness: 300, damping: 15 },
                      }}
                      whileTap={{ scale: 0.94 }}
                      onClick={() => setSelectedSubject(subject)}
                      className="cursor-pointer group relative flex flex-col items-center p-5 rounded-2xl
                      bg-white/5 backdrop-blur-md border border-white/10
                      hover:border-blue-500/70
                      hover:shadow-[0_0_30px_rgba(59,130,246,0.45)]
                      transition-all duration-300 overflow-hidden"
                    >
                      {/* subtle shine sweep on hover */}
                      <motion.div
                        className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-out pointer-events-none"
                      />

                      <motion.div
                        whileHover={{
                          rotate: [0, -6, 6, -3, 0],
                          transition: { duration: 0.5 },
                        }}
                      >
                        <FolderIcon className="w-20 h-20 drop-shadow-[0_0_12px_rgba(59,130,246,0.4)]" />
                      </motion.div>

                      <p className="text-white mt-4 text-center font-medium relative z-10">
                        {subject}
                      </p>
                    </motion.div>
                  ))}
                </motion.div>
              )}
            </motion.div>
          )}

          {/* Subject Page View */}
          {selectedSubject && (
            <motion.div
              key="subjectPage"
              initial={{ opacity: 0, x: 80 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -80 }}
              transition={{ duration: 0.45, ease: "easeOut" }}
              className="flex flex-col items-center"
            >
              <div className="w-full">
                <motion.button
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.1 }}
                  whileHover={{ scale: 1.05, x: -4 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => setSelectedSubject(null)}
                  className="mb-8 px-5 py-2 rounded-xl bg-blue-600 text-white shadow-[0_0_15px_rgba(59,130,246,0.4)]"
                >
                  ← Back
                </motion.button>
              </div>

              <motion.h2
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.15 }}
                className="text-3xl md:text-4xl font-bold text-white mb-10 text-center"
              >
                {selectedSubject}
              </motion.h2>

              <motion.div
                initial={{ opacity: 0, y: 40, scale: 0.9 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                transition={{ delay: 0.2, type: "spring", stiffness: 200, damping: 18 }}
                className="relative flex flex-col items-center gap-6 p-12 rounded-3xl
                bg-white/5 backdrop-blur-md border border-white/10
                hover:border-blue-500/70
                hover:shadow-[0_0_40px_rgba(59,130,246,0.45)]
                transition-all duration-300 overflow-hidden max-w-2xl w-full"
              >
                {/* animated glow ring behind icon */}
                <motion.div
                  animate={{
                    scale: [1, 1.15, 1],
                    opacity: [0.3, 0.6, 0.3],
                  }}
                  transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
                  className="absolute top-10 w-32 h-32 bg-blue-500 rounded-full blur-3xl"
                />

                <motion.div
                  animate={{ y: [0, -8, 0] }}
                  transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
                  className="relative z-10"
                >
                  <FolderIcon className="w-28 h-28 drop-shadow-[0_0_25px_rgba(59,130,246,0.6)]" />
                </motion.div>

                <p className="text-white/80 text-center max-w-sm relative z-10">
                  All previous year materials for{" "}
                  <span className="text-white font-medium">{selectedSubject}</span>{" "}
                  are available in these Google Drive folders.
                </p>

                {/* Folder Links Grid */}
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.3 }}
                  className="relative z-10 flex flex-wrap gap-3 justify-center"
                >
                  {materials[selectedSubject]?.folders?.map((folder, index) => (
                    <motion.a
                      key={index}
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.35 + index * 0.1 }}
                      whileHover={{
                        scale: 1.06,
                        boxShadow: "0 0 30px rgba(59,130,246,0.6)",
                      }}
                      whileTap={{ scale: 0.95 }}
                      href={folder.link}
                      target="_blank"
                      rel="noreferrer"
                      className="px-6 py-2 rounded-lg bg-gradient-to-r from-blue-600 to-cyan-500 text-white font-medium text-center shadow-[0_0_20px_rgba(59,130,246,0.4)] hover:shadow-[0_0_30px_rgba(59,130,246,0.6)] transition-all"
                    >
                      📁 {folder.name}
                    </motion.a>
                  ))}
                </motion.div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default PreviousMaterials;